import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API_ROOT } from '@Helpers/apiConfig';
import { createPacerApi } from '@Helpers/pacerApi';
import {
    projectListFiltersResponseSchema,
    ProjectListFiltersResponse,
} from './project.types';

export type { ProjectListFiltersResponse, ProjectOption } from './project.types';

// ---- Query keys ----

export const PROJECT_LIST_FILTERS_QUERY_KEY = 'ProjectListFilters';

// ---- Project List Filters ----

const loadProjectListFilters = async (subscriptionId: string): Promise<ProjectListFiltersResponse> => {
    const response = await createPacerApi()
        .post(`${API_ROOT}project/list-filters`, { json: { subscriptionId } })
        .json();
    const parsed = projectListFiltersResponseSchema.safeParse(response);
    if (!parsed.success) {
        console.warn('loadProjectListFilters: response did not match schema', parsed.error);
        return { userFavoriteProjects: [], projectOptionsDropdownList: [] };
    }
    return parsed.data;
};

export const useLoadProjectListFilters = (
    subscriptionId: string
): UseQueryResult<ProjectListFiltersResponse> =>
    useQuery<ProjectListFiltersResponse>({
        queryKey: [PROJECT_LIST_FILTERS_QUERY_KEY, subscriptionId],
        queryFn: () => loadProjectListFilters(subscriptionId),
        enabled: !!subscriptionId,
        initialData: { userFavoriteProjects: [], projectOptionsDropdownList: [] },
    });
